'use es6';

import Actions from 'AdsUI/lib/Actions';
import { List } from 'immutable';
import ConnectedUserRecord from 'AdsUI/records/users/ConnectedUserRecord';
export default ((state = new List(), action) => {
  const {
    type,
    payload
  } = action;

  switch (type) {
    case Actions.CONNECTED_USERS_FETCH_SUCCEEDED:
      {
        if (payload) {
          const connectedUsers = List(payload.map(user => new ConnectedUserRecord(user)));
          state = state.merge(connectedUsers);
        }

        break;
      }

    default:
      break;
  }

  return state;
});